/** @jsxImportSource @emotion/react */

import { CircleHelp, Minus, Plus } from 'lucide-react';
import { useSelector } from 'react-redux';

import EmptyButton from 'ud-ui/components/empty-button';
import useZoom from 'ud-ui/components/fabric-canvas/hooks/use-zoom';
import UDTippy from 'ud-ui/components/tippy';
import { selectFabricManager } from '../../../../store/editor/selectors';
import useTextBlockHelpModal from '../../../hooks/modals/text-block-help';
import { ZoomContainer } from './styles';

export function Zoom() {
  const manager = useSelector(selectFabricManager);
  const { increaseZoom, reduceZoom, zoom } = useZoom(manager);
  const { modal, open } = useTextBlockHelpModal();

  return (
    <ZoomContainer>
      <EmptyButton onClick={reduceZoom} icon={<Minus size={16} />} />
      {zoom}%
      <EmptyButton onClick={increaseZoom} icon={<Plus size={16} />} />
      <UDTippy content={'Подсказки по управлению'} placement={'top'}>
        <EmptyButton onClick={open} icon={<CircleHelp size={16} />} />
      </UDTippy>
      {modal}
    </ZoomContainer>
  );
}
